import styled from '@emotion/styled'

export const LayoutBackground = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  ${({ theme }) => `
    background-color: ${theme.colors.grey[1]};
  `}
`


export const LayoutContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  ${({ theme }) => `
    ${theme.breakpoints.desktop} {
      display: grid;
      grid-template-columns: 1fr 45%;
    }
  `}
  [dir="rtl"] & {
    direction: ltr;
  }
`

export const LayoutMainContent = styled.main`
  display: flex;
  flex-direction: column;
`

export const LayoutMainInner = styled.div`
  display: flex;
  flex-direction: column;
  ${({ theme }) => `
    ${theme.breakpoints.desktop} {
      display: grid;
      grid-template-rows: 1fr auto;
      height: 100vh;
      overflow: hidden;
      position: sticky;
      top: 0;
    }
  `}
  [dir="rtl"] & {
    direction: rtl;
  }
`

export const BodyContent = styled.div`
  overflow: auto;
  display: flex;
  flex-direction: column;
  ${({ theme }) => `
    ${theme.breakpoints.desktop} {
      min-height: 0;
    }
  `}
`

export const LayoutRightContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  ${({ theme }) => `
    background-color: ${theme.colors.neutrals.w};
    ${theme.breakpoints.desktop} {
      flex: unset;
      min-height: 100vh;
      overflow: hidden;
    }
  `}
  [dir="rtl"] & {
    direction: rtl;
  }
`
export const LayoutHeaderContainer = styled.header`
  /* istanbul ignore next */
  ${({ theme }) => `
    ${theme.breakpoints.desktop} {
      display: grid;
      grid-template-columns: 1fr 45%;
    }
  `}
  [dir="rtl"] & {
    direction: ltr;
  }
`

export const LayoutHeaderContent = styled.div`
  /* istanbul ignore next */
  ${({ theme }) => `
    background-color: ${theme.colors.neutrals.w};
    padding: 24px;
    border-bottom: 1px solid ${theme.colors.grey[2]};

    ${theme.breakpoints.desktop} {
      padding: 16px 64px;
      background-color: transparent;
      border-bottom: none;
      margin-bottom: 10px;
    }
  `}
`

export const LayoutHeaderIcon = styled.img`
  height: 33px;
`

export const LayoutHeaderWhiteContent = styled.div`
  /* istanbul ignore next */
  background-color: ${({ theme }) => theme.colors.neutrals.w};
`

